export const SCREEN_BREAKPOINTS = {
  sm: 640, // px
  md: 720, // px
  lg: 1024, // px
  xl: 1280, // px
  '2xl': 1536, // px
}
